
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'halfway_system',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/halfway_system.vue